const LOAD_DETAIL_PROVINCES           = 'LOAD_DETAIL_PROVINCES'
const LOAD_DETAIL_PROVINCES_SUCCESS   = 'LOAD_DETAIL_PROVINCES_SUCCESS'
const LOAD_DETAIL_PROVINCES_FAILED    = 'LOAD_DETAIL_PROVINCES_FAILED'
const UNMOUNT_DETAIL_PROVINCES        = 'UNMOUNT_DETAIL_PROVINCES'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const provincesDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_PROVINCES:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_PROVINCES_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_PROVINCES_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_PROVINCES:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default provincesDetailReducer;